import { z } from 'zod';
import { TFunction } from '../_hooks/useAddProductSchema';

export const getPricingTradeSchema = (t: TFunction) => z.object({
  minQty: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({
      required_error: t('requiredField'),
      invalid_type_error: t('acceptNumbersOnly'),
    })
      .int()
      .min(1, { message: t('moqMinMax', { min: 1, max: 5000 }) })
  ),
  leadTime: z.preprocess(
    (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
    z.number({
      required_error: t('requiredField'),
      invalid_type_error: t('acceptNumbersOnly'),
    })
      .int()
      .positive({ message: t('acceptNumbersOnly') })
      .max(100, { message: t('leadTimeMinMax', { min: 1, max: 100 }) })
  ),
  pricingTiers: z.array(
    z.object({
      minQty: z.preprocess(
        (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
        z.number().positive().optional()
      ),
      maxQty: z.preprocess(
        (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
        z.number().positive().optional()
      ),
      pricePerUnit: z.preprocess(
        (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
        z.number().positive().optional()
      ),
      internalLabel: z.string().optional(),
    })
  )
    .max(5, { message: t('maxItems', { value: 5 }) })
    .optional(),
});
